import Cookies from 'js-cookie';

const Cookieservice = (() => ({
  get: (name: string) => Cookies.get(name),
  remove: (name: string, options?: Cookies.CookieAttributes) => {
    const unixEpoch = new Date(0);

    Cookies.set(name, '', {
      path: '/',
      ...(options || {}),
      expires: unixEpoch,
    });
  },
  set: (name: string, value: string, options?: Cookies.CookieAttributes) => {
    Cookies.set(name, value, {
      path: '/',
      ...(options || {}),
    });
  },
}))();

export default Cookieservice;
